// PROA_TRIAL_30D_UNIFIED_V1
// PRC-018: entrada (A7) y bloqueo (D1–D3) sin callejones. Va por fuera de
// MainLayout para que las pantallas de bloqueo salgan sin menú lateral.
import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PricingEntryScreen from '../modules/pricingJourney/pages/PricingEntryScreen';
import PricingBlockedScreen from '../modules/pricingJourney/pages/PricingBlockedScreen';
import { usePricingOnboarding } from '../modules/pricingJourney/onboarding';
import { clearFirstAccess } from '../modules/pricingJourney/journeyAuth';

// PRC-019: el administrador ve la bienvenida (B1) una sola vez.
const WelcomeGate = () => {
  const location = useLocation();
  const { data } = usePricingOnboarding();
  if (data && !data.welcome_seen && location.pathname !== '/bienvenida') {
    return <Navigate to="/bienvenida" replace />;
  }
  return <Outlet />;
};

// El administrador sin acceso puede abrir Suscripción para contratar o reactivar.
const exemptWhenBlocked = new Set(['/subscription']);

const PricingAccessRoute = () => {
  const {
    hasResolvedPricingAccess, pricingRole, pricingAccess, isLoading,
    pricingContextError, pricingAccountMissing,
    industrialCostsRole, hasResolvedIndustrialCostsAccess, reloadPricingContext,
  } = useAuth();
  const location = useLocation();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const handle = window.setInterval(() => setNow(Date.now()), 15000);
    return () => window.clearInterval(handle);
  }, []);

  const trialEndedNow = pricingAccess?.state === 'trial' && pricingAccess?.has_access === true &&
    !!pricingAccess.trial_ends_at && new Date(pricingAccess.trial_ends_at).getTime() <= now;
  // La prueba terminó con la sesión abierta: se pide el estado para que D1 tenga sus fechas.
  useEffect(() => {
    if (trialEndedNow) reloadPricingContext();
  }, [trialEndedNow, reloadPricingContext]);

  const resolved = !isLoading && hasResolvedPricingAccess;
  // PRC-025: el primer acceso termina cuando la cuenta ha cargado.
  useEffect(() => {
    if (resolved) clearFirstAccess();
  }, [resolved]);

  if (!resolved) return <PricingEntryScreen mode="loading" />;
  if (pricingContextError) return <PricingEntryScreen mode="error" />;
  if (!pricingRole) {
    // Un usuario de Industrial sin Pricing vuelve a su aplicación.
    if (!hasResolvedIndustrialCostsAccess) return <PricingEntryScreen mode="loading" />;
    if (industrialCostsRole) return <Navigate to="/industrial-cost" replace />;
    return <PricingEntryScreen mode={pricingAccountMissing ? 'missing' : 'error'} />;
  }
  const ended = pricingAccess?.trial_ends_at
    ? new Date(pricingAccess.trial_ends_at).getTime() <= now : false;
  const entitled = pricingAccess?.has_access === true &&
    (pricingAccess.state === 'paid' || (pricingAccess.state === 'trial' && !ended));
  if (!entitled) {
    if (pricingRole === 'admin' && exemptWhenBlocked.has(location.pathname)) return <Outlet />;
    return <PricingBlockedScreen />;
  }
  if (pricingRole === 'admin') return <WelcomeGate />;
  return <Outlet />;
};

export default PricingAccessRoute;
